export default "__VITE_ASSET__cbeb6c42__"